import React, { useState } from 'react'
import styles from './LeadQualityScreen.module.css'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LeadQualityBarChart from './LeadQualityBarChart';
import LeadSummaryDataInsufficientComponent from './LeadSummaryDataInsufficientComponent';
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import LeadRecommendationPopupContent from './LeadRecommendationPopupContent';

interface LeadSummaryFollowupCardComponentProps {
    data: any,
}

const LeadSummaryFollowupCardComponent: React.FC<LeadSummaryFollowupCardComponentProps> = ({ data }) => {
    const [openReadMore, setOpenReadMore] = useState<boolean>(false);
    const readMoreHandler  = () => {
        document.body.classList.add("no-overflow");
        setOpenReadMore(true)
    }
    let leadCallingScoreType = data?.leadCallingScoreType ? data.leadCallingScoreType.toLowerCase() : "";
    return (
        <div className={styles.LqscsCard}>
            <div className={styles.LqscsCardHeader}>
                <div className={styles.LqscsCardTitle}>{data.cardTitle}</div>
                <div className={styles.LqscsCardSubTitle}>{data.cardSubtitle}</div>
            </div>
            {
                (data.report_display === "N") ?
                    <LeadSummaryDataInsufficientComponent
                        leadHighlightText={data.thresholdDesc}
                        infoBannerText="Follow up calling increases chances of conversion"
                        data={data}
                    />
                    :
                    <div className={styles.LqscsCardBody}>
                        <div className={`${styles.LqscsCardBodyLeft} ${styles["hasBarChart"]}`}>
                            <div><LeadQualityBarChart chartDatas={[data.leadwithonetotwoattempt, data.leadwiththreeplusattempt]} backgrounds={["#279ea0", "#f197a2"]} labels={['Leads with 1-2 attempts', 'Leads with 3+ attempts']} canvasId="followupcallChart" /></div>
                            <div className={styles.LqscsCallingDatabox}>
                                <div className={styles.LqscsCallData}>
                                    <div className={styles.LqscsCallDataLabelBar}>Leads with <br /> 1-2 attempts</div>
                                </div>
                                <div className={styles.LqscsCallData}>
                                    <div className={styles.LqscsCallDataLabelBar}>Leads with <br /> 3+ attempts</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.LqscsCardBodyRight}>
                            <div className={styles.LqscsPercentageInfo}>
                                <div className={styles.LqscsPercentageData}>
                                    <div className={styles.LqscsPercentageDataVal}>{data.leadCalledPercent}<span className={styles.LqscsPercentageDataLabel}>Leads Called</span></div>
                                    <div className={styles.LqscsPercentageDataLabel}>3+ times in case of no response</div>
                                </div>
                                <div className={styles.LqscsScroreType}>
                                    <div className={`${styles.LqscsTitleTag} ${styles[leadCallingScoreType]}`}>{leadCallingScoreType}</div>
                                    {(leadCallingScoreType !== "moderate") && <div className={`${styles.LqscsScroreTypeTxt} ${styles[leadCallingScoreType]}`}>Among {(leadCallingScoreType == "good") && "Top"} {(leadCallingScoreType == "poor") && "Bottom"} 20%</div>}
                                </div>
                            </div>
                            <div className={styles.LqscsHighlight}>Top agents in your city follow up on {data.topBenchmark} of leads.</div>
                            <div className={`${styles.LqscsBanner} ${styles[leadCallingScoreType]}`}>
                                <span className={`${styles.LqscsBannerIcon} ${styles[leadCallingScoreType]}`}>
                                    {(leadCallingScoreType == "good") && <ThumbUpIcon className={styles.ThumbUpIcon} />}
                                    {(leadCallingScoreType == "moderate") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                    {(leadCallingScoreType == "poor") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                </span>
                                {
                                    data.leadCallingScoreMessage
                                    // (leadCallingScoreType == "good") ? "Follow up calling increases chances of conversion"
                                    //     :
                                    //     (leadCallingScoreType == "moderate") ? "Follow up calling increases chances of conversion"
                                    //         :
                                    //         (leadCallingScoreType == "poor") ? "Follow up calling increases chances of conversion"
                                    //             :
                                    //             ""
                                }
                                <span className={styles.ReadMoreCta} onClick={readMoreHandler}>Read More</span>
                            </div>
                        </div>
                    </div>
            }
            {
                openReadMore && <CenteredPopUp
                    setModal={setOpenReadMore}
                    children={
                        <LeadRecommendationPopupContent 
                        title={"Follow-up Calls"}
                        subtext={"This metric tracks follow-ups—3+ call attempts within a day for unresponsive leads"}
                        recommendation={"Same-day follow-ups improve response rates and enhance lead qualification"}
                        scoreType={leadCallingScoreType}
                        />
                    }
                    modiferClass={styles.LcqModal}
                    closeIcon={true}
                    closeClassMofifier={styles.LcqModalClose}
                />
            }
        </div>
    )
}

export default LeadSummaryFollowupCardComponent